import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import Component from "./-components/component";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/item-sales-velocity/")({
  component: Component,
  validateSearch: SearchParams,
});